import { useForm } from 'react-hook-form';

import Button from '../../Button';
import { OtpFieldWithResendBtn } from '../../ResendButton';
import useResendOtpHook from '../../ResendButton/useResendOtpHook';
import OnboardingLayout from '../OnboardingLayout';

const MobileVerifyOTP = ({ state, dispatch }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { resendOtp, resendOtpHandler } = useResendOtpHook(dispatch, '/v2/getOTPWithMobile');

  function onSubmit(values) {
    dispatch({
      type: 'UPDATE_PAYLOAD',
      value: values,
    });
    dispatch({
      type: 'PUSH_VIEW_HISTORY',
      value: MobileVerifyOTP,
    });
    dispatch({
      type: 'UPDATE_ENDPOINT',
      value: '/v3/verifyOtpWithMobile',
    });
  }

  return (
    <OnboardingLayout>
      <header className="onboard-header">
        <OnboardingLayout.Back dispatch={dispatch} />
        <h1 className="h2 onboard-title">
          Please enter the 6-digit OTP sent via SMS to verify your mobile number.
        </h1>
      </header>
      <form onSubmit={handleSubmit(onSubmit)} className="gtm-onboarding" id="mobile-verify-otp">
        <fieldset disabled={state.endpoint}>
          <OtpFieldWithResendBtn
            resendOtp={resendOtp}
            resendOtpHandler={resendOtpHandler}
            errors={errors}
            register={register}
          />
          <Button block type="submit" data-testid="verify-otp">
            Next
          </Button>
        </fieldset>
      </form>
    </OnboardingLayout>
  );
};

export default MobileVerifyOTP;
